/** ja 国家/地区落地页 */
export default {
  "label": "Japan",
  "path": "/locations/free-japan-vpn/",
  "hreflang": "ja",
  "htmlLang": "ja",
  "title": "Secure VPN｜日本のIPアドレスを使える無料VPN",
  "description": "Secure VPNでインターネット接続を保護し、日本のIPアドレスを利用する方法や利用可能なサーバー、VPNの設定手順を確認しましょう。",
  "h1": "日本のIPアドレスを使える無料VPN",
  "heroLead": "Secure VPNをダウンロードして、ブラウジング、ストリーミング、ゲーム、オンラインプライバシーを保護する高速な暗号化接続を利用しましょう。",
  "heroPoints": [
    "1台のデバイスを保護",
    "ログ・広告なし",
    "無制限で無料",
    "グローバルVPNサーバー"
  ],
  "heroCtaLabel": "APKをダウンロード",
  "privacyTitle": "無料VPNでプライバシーを保護",
  "privacyLead": "Secure VPNは、インターネット利用時のプライバシーを守るためのシンプルなVPNアプリです。ワンタップで安全なサーバーに接続し、IPアドレスを隠して、公共Wi-Fi、モバイルネットワーク、自宅回線をより安全に利用できます。複雑な設定なしで高速な保護を求めるユーザーに適しています。",
  "privacySubtitle": "主なメリット",
  "privacyBenefits": [
    {
      "title": "100%無料・無制限",
      "desc": "毎日のデータ制限や隠れた料金なしでVPNを利用できます。"
    },
    {
      "title": "公共Wi-Fi保護",
      "desc": "カフェ、空港、ホテルなどの共有ネットワークをより安全に利用できます。"
    },
    {
      "title": "ノーログポリシー",
      "desc": "VPN利用中に訪れたウェブサイトの記録を保持しません。"
    }
  ],
  "featuresTitle": "Secureの無料VPNでできること",
  "featureCards": [
    {
      "title": "暗号化されたオンライン保護",
      "desc": "強力な暗号化で個人データとインターネット通信を保護します。"
    },
    {
      "title": "高速グローバルサーバー",
      "desc": "世界の高速VPNサーバーに接続し、ブラウジングや動画視聴を快適に。"
    },
    {
      "title": "多彩なサーバーロケーション",
      "desc": "各国のサーバーを選び、どこでも安定した接続を利用できます。"
    },
    {
      "title": "ワンタップ接続",
      "desc": "複雑な設定なしで、最適なサーバーへすぐに接続できます。"
    },
    {
      "title": "世界各地のサーバー",
      "desc": "必要なときに高速で信頼できるグローバルVPNサーバーへ接続。"
    },
    {
      "title": "スムーズなストリーミング",
      "desc": "動画やライブ配信、オンラインエンタメを安定した接続で楽しめます。"
    },
    {
      "title": "高速パフォーマンス",
      "desc": "最適化されたサーバーがブラウジングやゲームに安定した速度を提供します。"
    },
    {
      "title": "100%無料・無制限",
      "desc": "毎日のデータ制限や隠れた料金なしでVPNを利用できます。"
    }
  ],
  "extraTitle": "Secure VPNを使う理由",
  "extraItems": [
    "軽量で使いやすい",
    "公共Wi-Fi保護",
    "IPアドレスを隠す",
    "制限の少ないブラウジング",
    "高速で安定したサーバー"
  ],
  "extraCta": "APKをダウンロード",
  "extraPlayPrefix": "Download from",
  "dailyTitle": "毎日のオンライン生活でSecure VPNを活用",
  "dailyScenes": [
    {
      "title": "ネットワーク制限のないゲーム",
      "tags": [
        "PUBG Mobile",
        "Call of Duty: Mobile",
        "Free Fire",
        "Mobile Legends"
      ]
    },
    {
      "title": "プライベートなビデオ通話とメッセージ",
      "tags": [
        "WhatsApp",
        "Telegram",
        "Skype",
        "Viber"
      ]
    },
    {
      "title": "公共Wi-Fiでも安全に接続",
      "tags": [
        "公共Wi-Fi",
        "職場",
        "学校",
        "空港"
      ]
    },
    {
      "title": "オンラインプライバシーを保護",
      "tags": [
        "強力な暗号化",
        "IPアドレスを隠す",
        "ノーログポリシー",
        "ISPから保護"
      ]
    }
  ],
  "installTitle": "Secure VPNアプリのダウンロードとインストール方法",
  "installLead": "次の簡単な手順に従ってください。",
  "installSteps": [
    {
      "title": "ダウンロードページを開く",
      "desc": "Secure VPNのダウンロードページまたは信頼できるアプリストアで最新版を入手します。"
    },
    {
      "title": "Secure VPNをダウンロード",
      "desc": "ダウンロードを押し、APKまたはアプリファイルの完了を待ちます。"
    },
    {
      "title": "インストール権限を有効化",
      "desc": "APKの場合は、ブラウザまたはファイル管理アプリに提供元不明アプリのインストールを許可します。"
    },
    {
      "title": "アプリをインストール",
      "desc": "ダウンロードしたファイルを開き、インストールを押して完了させます。"
    },
    {
      "title": "開いて接続",
      "desc": "Secure VPNを起動し、サーバーを選び、接続を押して安全なVPN接続を開始します。"
    },
    {
      "title": "安全なブラウジングを楽しむ",
      "desc": "通信が保護されました。ブラウジング、動画、ゲーム、公共Wi-Fiをより安全に利用できます。"
    }
  ],
  "installCta": "APKをダウンロード",
  "compareTitle": "Secure VPNアプリと無料ウェブプロキシの比較",
  "compareLead": "Secure VPNアプリと無料ウェブプロキシはどちらもインターネット利用をよりプライベートにしますが、仕組みは異なります。VPNは暗号化接続で端末全体を保護し、ウェブプロキシは主にブラウザからの簡単なアクセス向けです。",
  "compareNote": "日常的なインターネット利用では、Secure VPNアプリの方がより完全で信頼できる安全な接続を提供します。",
  "compareHeaders": [
    "機能",
    "Secure VPNアプリ",
    "無料ウェブプロキシ"
  ],
  "compareRows": [
    {
      "feature": "インストール",
      "vpn": "簡単なアプリ設定",
      "proxy": "インストール不要"
    },
    {
      "feature": "利用範囲",
      "vpn": "すべてのアプリとサイトを保護",
      "proxy": "ブラウザ内のみ"
    },
    {
      "feature": "プライバシー",
      "vpn": "強力な暗号化と安全な接続",
      "proxy": "基本的なブラウジング保護"
    },
    {
      "feature": "接続速度",
      "vpn": "最適化されたVPNサーバー",
      "proxy": "プロキシサーバーによる"
    },
    {
      "feature": "端末保護",
      "vpn": "端末全体を保護",
      "proxy": "ブラウザレベルのみ"
    }
  ],
  "privacyChoiceTitle": "どちらを選ぶべき？",
  "privacyChoiceP1": "より強力なプライバシー、高速接続、端末全体の保護が必要な場合。より強力なプライバシー、高速接続、端末全体の保護が必要な場合。",
  "privacyChoiceP2": "簡単な作業のために一時的なブラウザアクセスだけが必要な場合。",
  "privacyChoiceP3": "日常的なインターネット利用では、Secure VPNアプリの方がより完全で信頼できる安全な接続を提供します。",
  "reviewsTitle": "ユーザーからの信頼",
  "reviewsLead": "世界中のユーザーが高速で安定し、安全な接続のためにSecure VPNを選んでいます。信頼できるサーバーとプライバシー保護で、毎日のブラウジング、動画視聴、ゲーム、通信を安全に保ちます。",
  "reviews": [
    {
      "name": "James",
      "text": "接続が速く、使い方も簡単です。どこでも安全にブラウジングできます。"
    },
    {
      "name": "Emily",
      "text": "Secure VPNはスムーズに動作し、公共Wi-Fiでも接続が安定しています。"
    },
    {
      "name": "Daniel",
      "text": "ストリーミング、ゲーム、日常利用に十分な速度と信頼できるサーバーです。"
    }
  ],
  "faqTitle": "よくある質問",
  "faqs": [
    {
      "q": "VPNを使うとインターネットが遅くなりますか？",
      "a": "通信が安全なサーバーを通るため速度が少し低下する場合があります。通常は影響が小さく、ブラウジングや動画、アプリ利用に問題はほとんどありません。"
    },
    {
      "q": "SecureVPNは安全ですか？",
      "a": "SecureVPNは接続を暗号化しIPアドレスを隠してプライバシーを守ります。信頼できる提供元から入手し、プライバシーポリシーを確認してください。"
    },
    {
      "q": "VPNの利用は合法ですか？",
      "a": "多くの国ではVPNはプライバシーとセキュリティのために合法的に利用されています。地域の法律や規制に従ってください。"
    },
    {
      "q": "どのくらい接続できますか？",
      "a": "保護された接続が必要な間はSecureVPNを利用できます。接続制限はアプリのバージョンやサービス条件により異なる場合があります。"
    },
    {
      "q": "Secure VPNの使い方は？",
      "a": "Secure VPNをインストールして開き、サーバーを選び、接続ボタンを押します。接続後は通信がVPNを通ります。"
    },
    {
      "q": "VPNはバッテリーに影響しますか？",
      "a": "接続を維持するため少し余分に電池を使う場合がありますが、通常の使用で大きな影響はほとんどありません。"
    }
  ]
};
